import { useState, useEffect, useRef } from 'react';
import { TOAST_OPTIONS } from '../../constants';
// import { parsePhoneNumber } from 'libphonenumber-js';

//UTILS
import TokenService from "../../services/token_services";
import UserService from "../../services/user_services";
import { ToastContainer, toast } from 'react-toastify';
import { Buffer } from 'buffer';

//COMPONENTS
import Menu from '../../components/menu';
import BoardHeader from '../../components/boardheader';
import Button from '../../components/button';
import { ThreeDots } from 'react-loader-spinner';

//TRANSLATION
import { useTranslation } from 'react-i18next';

const Profile = ({ magic }) => {
    const { t } = useTranslation();
    const inputRef = useRef();
    const [profile, setProfile] = useState({});
    const [firstname, onChangeFirstname] = useState("");
    const [lastname, onChangeLastname] = useState("");
    const [birthdate, onChangeBirthdate] = useState("");
    const [avExt, onChangeExtension] = useState(null);
    const [avB64, onChangeB64] = useState(null);
    const [loading, onChangeLoading] = useState(null);
    /* const [countryCode, onChangeCountryCode] = useState('33');
    const [phoneNumber, onChangePhoneNumber] = useState(null);
    const [success, onChangeSuccess] = useState(false);
    const [twoFAToken, onChangeTwoFAToken] = useState(null); */

    const handleAvatarUpload = () => { inputRef.current.click() }

    const onAvatarHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['jpg', 'png', 'jpeg'].includes(extension)) {
            toast.error(t('profile.invalid_img_ext'), TOAST_OPTIONS);
        } else if (event.target.files[0].size > 32000000) {
            toast.error(t('profile.img_size_exceed'), TOAST_OPTIONS);
        } else {
            onChangeExtension(extension)
            reader.onloadend = () => processFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    const processFile = (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        onChangeB64(base64data)
    }

    useEffect(() => {
        const data = TokenService.getUser();
        setProfile(data.account);
        onChangeFirstname(data.account.firstname || "");
        onChangeLastname(data.account.lastname || "");
        onChangeBirthdate(data.account.birthdate || "");
        onChangeB64(data.account.selfie);
        onChangeExtension(data.account.selfie_ext);

        // Parse phone number using libphonenumber-js
        /* let countryCode = '33'; // default to France
        let phoneNumber = null; */

        /* if (data.account.phone) {
            try {
                const parsed = parsePhoneNumber(data.account.phone);
                if (parsed && parsed.isValid()) {
                    countryCode = parsed.countryCallingCode;
                    phoneNumber = parsed.nationalNumber;
                } else {
                    // Fallback: try to parse manually if library fails
                    console.warn('Could not parse phone number with library, using fallback');
                    const cleanPhone = data.account.phone.replace(/\D/g, ''); // Remove non-digits
                    if (cleanPhone.length > 2) {
                        countryCode = cleanPhone.slice(0, 2);
                        phoneNumber = cleanPhone.slice(2);
                    }
                }
            } catch (error) {
                console.warn('Phone number parsing error:', error);
                // Fallback to manual parsing
                const cleanPhone = data.account.phone.replace(/\D/g, '');
                if (cleanPhone.length > 2) {
                    countryCode = cleanPhone.slice(0, 2);
                    phoneNumber = cleanPhone.slice(2);
                }
            }
        } */

        //onChangeCountryCode(countryCode);
        //onChangePhoneNumber(phoneNumber);
    }, []);

    const logout = () => {
        magic.user.logout().then(() => {
            UserService.logout()
        });
    }

    /* const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        onChangeCountryCode(selectedCode);
    }; */

    /* const updtPhone = async () => {
        if (!countryCode || !phoneNumber) {
            toast.error(t('profile.set_phone'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading("phone");
                const phone = `+${countryCode}${phoneNumber}`;
                const resp = await UserService.updateProfilePhone(phone);
                console.log(resp);
                if (resp.status) {
                    onChangeSuccess(true);
                    onChangeLoading(null);
                }
                else {
                    toast.error(resp.message, TOAST_OPTIONS);
                    onChangeLoading(null);
                }
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(null);
            }
        }
    }

    const validateTwoFA = async () => {
        if (!twoFAToken) {
            toast.error(t('profile.set_code'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading("phone");
                const resp = await UserService.verify2FA(twoFAToken);
                console.log(resp);
                if (resp.status) {
                    onChangeSuccess(false);
                    onChangeLoading(null);
                    toast.success(t('profile.phone_updated'), TOAST_OPTIONS);
                }
                else {
                    toast.error(resp.message, TOAST_OPTIONS);
                    onChangeLoading(null);
                }
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(null);
            }
        }
    } */

    const updateProfile = async () => {
        if (!firstname)
            toast.error(t('profile.error_firstname'), TOAST_OPTIONS);
        else if (!lastname)
            toast.error(t('profile.error_lastname'), TOAST_OPTIONS);
        else {
            onChangeLoading("profile");
            try {
                const resp = await UserService.updateProfile(firstname, lastname, birthdate, avB64, avExt);
                if (resp.status) {
                    toast.success(t('profile.profile_updated'), TOAST_OPTIONS);
                } else
                    toast.error(resp.message, TOAST_OPTIONS);
            } catch (e) {
                console.log(e.response.data)
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
            }
            onChangeLoading(null);
        }
    }

    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={t('profile.profile')} />
                <div className="content">
                    <p><strong>{t('profile.edit_profile')}</strong></p>
                    <div className="big_avatar"
                        onClick={handleAvatarUpload}
                        style={{
                            backgroundImage: avB64 ? `url('data:image/${avExt};base64,${avB64}')` :
                                `url('https://api.dicebear.com/9.x/pixel-art-neutral/svg?seed=${profile.user_uuid}.png')`
                        }}>
                    </div>
                    <input className="display-none" type="file" ref={inputRef}
                        accept="image/png,image/jpeg"
                        onChange={(e) => onAvatarHandler(e)} />
                    <small>{t('profile.press_picture')}</small>
                    <div className="mt-30">
                        <label>{t('profile.firstname')}</label>
                        <input type="text" value={firstname} onChange={(e) => onChangeFirstname(e.target.value)} />
                    </div>
                    <div className="mt-10 mb-20">
                        <label>{t('profile.lastname')}</label>
                        <input type="text" value={lastname} onChange={(e) => onChangeLastname(e.target.value)} />
                    </div>
                    <div className="mt-10 mb-20">
                        <label>{t('profile.birthdate')}</label>
                        <input type="date" value={birthdate} onChange={(e) => onChangeBirthdate(e.target.value)} />
                    </div>
                    <Button title={t('profile.update_profile')} loading={loading === "profile"} click={updateProfile} />
                    <ThreeDots visible={loading === "profile"} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                    {/* <p className="mt-30 mb-5"><strong>{t('profile.edit_phone')}</strong></p>
                    {success ?
                        <React.Fragment>
                            <div className="display-inline-block mr-20 mt-0">
                                <label>{t('profile.fatoken')}</label>
                                <input type="text" className="semi mt-10" placeholder={t('profile.code')} onChange={e => onChangeTwoFAToken(e.target.value)} />
                            </div>
                            <div className="mt-20">
                                <Button title={t('profile.confirm')} loading={loading === "phone"} click={validateTwoFA} />
                                <ThreeDots visible={loading === "phone"} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="display-inline-block mr-20 mt-0">
                                <label>{t('profile.country')}</label>
                                <select className="semi" onChange={handleCountryChange} value={countryCode || '33'}>
                                    {europeanCountries.map((country) => (
                                        <option key={country.code} value={country.code} selected={country.code === countryCode}>
                                            {country.name} (+{country.code})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="display-inline-block mt-0">
                                <label>{t('profile.phone_number')}</label>
                                <input type="tel" className="semi" placeholder="123456789" value={phoneNumber} onChange={e => onChangePhoneNumber(e.target.value)} />
                            </div>
                            <div className="mt-20">
                                <Button title={t('profile.update_phone')} loading={loading === "phone"} click={updtPhone} />
                                <ThreeDots visible={loading === "phone"} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                            </div>
                        </React.Fragment>} */}
                </div>
                <div className="disconnect">
                    <Button title={t('profile.disconnect')} click={logout} />
                </div>
            </div>
            <ToastContainer />
        </div>
    )
};

export default Profile;